import React from 'react'
import TextInput from '../../TextInput/TextInput'
import { FieldArray, useField } from 'formik'
import { getFieldValidationErrorMessageDOM, AddInstanceButton, ContextualDropdown, isFieldMultiple, contextualDropdownActionArray, ReadOnlyField } from '../helper'
import { modeTypes } from '../constants'

const MultipleInstance = ({ field, fieldWidth, mode }) => {
  const { formFieldUid } = field;

  const [textFields, textMeta] = useField(formFieldUid);
  // ${(field?.maxLength && field?.showCharacterCount) ? 'adjust-margin-top' : ''} ${(field?.errorMessage?.[index]) ? 'adjust-margin-left' : ''} `}
  return <FieldArray name={formFieldUid}>
    {({ insert, remove, move, push }) => {
      const isReadOnly = mode === modeTypes.readOnly || field.readOnly
      return <div data-test-id={`cs-asset-details-field-${formFieldUid}-multiple-instance-wrapper`}>
        {textFields?.value?.map?.((item, index) => (
          <div className='asset-details-v2-fields-container__single-line-text-container__item' key={index} data-test-id={`cs-asset-details-field-${formFieldUid}-multiple-instance-item-${index}-wrapper`}>
            <div className={`asset-details-v2-fields-container__single-line-text-container__item__input-container `}

            >
              <div className='growContainer'>
                {isReadOnly ? <ReadOnlyField width={fieldWidth} showCopyIcon={field.showCopyIcon} value={item} copyLabel={field.title} copyIconSize={'small'} testId={`${formFieldUid}.${index}`} copyContent={isReadOnly ? item : ''} />
                  : <TextInput
                    placeholder={field.placeholder || ''}
                    // className={field.className || ''}
                    testId={`cs-asset-details-field-${formFieldUid}-multiple-instance-item-${index}-input`}
                    version={'v2'}
                    width={fieldWidth}
                    maxLength={field?.maxLength}
                    showCharacterCount={field?.showCharacterCount}
                    {...textFields}
                    value={item || ''}
                    name={`${formFieldUid}.${index}`}
                    error={textMeta.touched && textMeta.error?.[index]}
                    onlyLabel={isReadOnly}
                    showCopyIcon={isReadOnly}
                    copyContent={isReadOnly ? item : ''}
                    copyLabel={isReadOnly ? field.title : ''}
                    copyIconSize={'small'}
                  />}
              </div>
              {!isReadOnly && <ContextualDropdown contextualDropdownActionArray={contextualDropdownActionArray(field, index, remove)} field={field} />}
            </div>
            {Array.isArray(textMeta.error)
              ? getFieldValidationErrorMessageDOM(textMeta, index, undefined, `cs-asset-details-field-${formFieldUid}-multiple-instance-item-${index}-validation-message`)
              : null}
          </div>
        ))}
        {typeof textMeta.error === 'string' && getFieldValidationErrorMessageDOM(textMeta, undefined, undefined, `cs-asset-details-field-${formFieldUid}-multiple-instance-validation-message`)}
        <div>
          {!isReadOnly && field.multiple && <AddInstanceButton field={field} valueLength={textFields?.value?.length} push={push} />}
        </div>
      </div>
    }}
  </FieldArray>
}

const SinglelineText = (props: any) => {
  const { field, fieldWidth, mode } = props

  const { formFieldUid } = field;

  const [textField, textMeta] = useField(formFieldUid);

  const isMultiple = isFieldMultiple(field);
  const isReadOnly = mode === modeTypes.readOnly || field.readOnly
  return (
    <div className='asset-details-v2-fields-container__single-line-text-container' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-wrapper`}>
      {isMultiple
        ? <MultipleInstance field={field} fieldWidth={fieldWidth} mode={mode} />
        : <div className='asset-details-v2-fields-container__single-line-text-container__item'>
          <div>
            {isReadOnly ? <ReadOnlyField width={fieldWidth} showCopyIcon={field.showCopyIcon} value={textField.value} copyLabel={field.title} copyIconSize={'small'} testId={formFieldUid} copyContent={isReadOnly ? textField.value : ''} />
              : <TextInput
                placeholder={field.placeholder || ''}
                // className={field.className || ''}
                testId={`cs-asset-details-field-${field?.formFieldUid}-input`}
                version={'v2'}
                width={fieldWidth}
                maxLength={field?.maxLength}
                {...textField}
                value={textField.value || ''}
                showCharacterCount={field?.showCharacterCount}
                error={textMeta.touched && textMeta.error}
                onlyLabel={isReadOnly}
                showCopyIcon={isReadOnly}
                copyContent={isReadOnly ? textField.value : ''}
                copyLabel={isReadOnly ? field.title : ''}
                copyIconSize={'small'}
              />}
          </div>
          {getFieldValidationErrorMessageDOM(textMeta, undefined, undefined, `cs-asset-details-field-${field?.formFieldUid}-validation-message`)}
        </div>}
    </div>
  )
}

export default SinglelineText